export default __webpack_public_path__ + "7011ff6190312ff762aa41634e7a0ade.woff";